import { render, staticRenderFns } from "./TaskRemovedTags.vue?vue&type=template&id=42b44d6a&scoped=true"
import script from "./TaskRemovedTags.vue?vue&type=script&lang=js"
export * from "./TaskRemovedTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b44d6a",
  null
  
)

export default component.exports